export default __webpack_public_path__ + "static/media/meow.46e341f4.wav";